import { useEffect, useMemo } from "react";

import logo from "../images/logo.webp";
import "../css/Maintenance.css";

const Maintenance = ({
  settings,
  checking,
  onRetry,
  preservingSession = false,
}) => {
  const estimatedTime = useMemo(() => {
    if (!settings.estimatedEndAt) {
      return null;
    }

    const parsed = new Date(settings.estimatedEndAt);

    if (Number.isNaN(parsed.getTime())) {
      return null;
    }

    return new Intl.DateTimeFormat("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(parsed);
  }, [settings.estimatedEndAt]);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Temporarily unavailable | Graphe Weddings";

    let robots = document.querySelector('meta[name="robots"]');
    const previousRobots = robots?.getAttribute("content");
    const createdRobots = !robots;

    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }

    robots.setAttribute("content", "noindex, nofollow");

    return () => {
      document.title = previousTitle;

      if (createdRobots) {
        robots.remove();
      } else if (previousRobots) {
        robots.setAttribute("content", previousRobots);
      }
    };
  }, []);

  return (
    <main className="maintenance-page" role="main">
      <div className="maintenance-orbit maintenance-orbit-one" />
      <div className="maintenance-orbit maintenance-orbit-two" />

      <section className="maintenance-card" aria-live="polite">
        <div className="maintenance-logo-wrap">
          <img src={logo} alt="Graphe Weddings" />
        </div>

        <p className="maintenance-eyebrow">
          {settings.unavailable ? "Service pause" : "A brief interlude"}
        </p>

        <h1>{settings.title}</h1>

        <div className="maintenance-divider" aria-hidden="true">
          <span />
          <i />
          <span />
        </div>

        <p className="maintenance-message">{settings.message}</p>

        {estimatedTime && (
          <p className="maintenance-estimate">
            <span>Expected return</span>
            {estimatedTime}
          </p>
        )}

        {preservingSession && (
          <p className="maintenance-preserved">
            <i className="pi pi-shield" aria-hidden="true" />
            This page is paused in the background, so your current selections
            will still be here when service resumes.
          </p>
        )}

        <button
          type="button"
          className="maintenance-retry"
          onClick={onRetry}
          disabled={checking}
        >
          <i
            className={`pi ${checking ? "pi-spin pi-spinner" : "pi-refresh"}`}
            aria-hidden="true"
          />
          {checking ? "Checking..." : "Check again"}
        </button>

        <a
          className="maintenance-contact"
          href="mailto:contact@grapheweddings.com"
        >
          contact@grapheweddings.com
        </a>
      </section>
    </main>
  );
};

export default Maintenance;
